document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('shopizi-sticky-atc');
  if (!container) return;

  // Botão original do Horizon
  const findOriginalButton = () =>
    document.querySelector("button[id^='BuyButtons-ProductSubmitButton-']");

  const originalButton = findOriginalButton();
  if (!originalButton) return;

  // Clona o botão (visual idêntico)
  const clone = originalButton.cloneNode(true);
  clone.removeAttribute('id'); // evita IDs duplicados
  clone.setAttribute('aria-hidden', 'false');

  // Clique no clone dispara o original
  clone.addEventListener('click', (e) => {
    e.preventDefault();
    originalButton.click();
  });

  container.appendChild(clone);

  // Mostrar após “2 scrolls”
  const triggerY = Math.round(window.innerHeight * 2.3);

  const update = () => {
    if (window.scrollY >= triggerY) {
      container.classList.add('is-visible');
      container.setAttribute('aria-hidden', 'false');
    } else {
      container.classList.remove('is-visible');
      container.setAttribute('aria-hidden', 'true');
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
});
